import { DialogContent, DialogTitle, Typography } from "@mui/material";
import { TrashIcon } from "../svgicons/SvgIcons";

interface DialogProps {
  textTitle?: string;
  textChildren?: any;
  /** Aviso adicional bajo la pregunta, p. ej. lo que se borra en cascada. */
  warningText?: string;
  actionButton?: any;
  onSubmit?: any;
  cancelModal?: any;
}

const DeleteModal = ({
  textTitle,
  textChildren,
  warningText,
  actionButton,
  onSubmit,
  cancelModal,
}: DialogProps) => {
  return (
    <>
      <DialogTitle id="alert-dialog-title" sx={{ pt: 4, px: 4 }}>
        <TrashIcon sx={{ fontSize: "1rem", width: 16, color: "#CC0000" }} />
        {"Eliminar registro"}
      </DialogTitle>
      <DialogContent sx={{ px: 4, py: 8, mt: 8 }}>
        {"¿Estás seguro de eliminar el registro?"}{" "}
        <strong>{textChildren}</strong>
        {warningText && (
          <Typography color="error" sx={{ mt: 4 }}>
            {warningText}
          </Typography>
        )}
      </DialogContent>
      {actionButton}
    </>
  );
};

export default DeleteModal;
